import { __assign } from 'tslib';
import React from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import { classNames } from '@panwds/react-ui';
import { arrayMoveImmutable } from '../../utils/arrayMove.esm.js';
import { useTableLayoutEnabled } from '../TableLayout/TableLayout.esm.js';
import '@panwds/icons';
import 'uuid';
import '../TableContext/TableContext.esm.js';
import '../TableContext/TableProvider.esm.js';
import 'react-intl';
import { HeaderCell } from './HeaderCell.esm.js';

var OrderableColumnGroup = SortableContainer(function (props) { return React.createElement("div", __assign({}, props)); });
/**
 * Group the columns into the sections the will be rendered.
 */
function groupColumns(columns) {
    return columns.reduce(function (accum, column) {
        if (column.isSortRowColumn) {
            accum.sortRowColumn.push(column);
        }
        else if (column.isSelectRowColumn) {
            accum.selectRowColumn.push(column);
        }
        else if (column.isGrouped) {
            accum.groupedColumns.push(column);
        }
        else if (column.sticky) {
            if (column.stickyPosition === "left") {
                accum.leftStickyColumns.push(column);
            }
            else {
                accum.rightStickyColumns.push(column);
            }
        }
        else {
            accum.generalColumns.push(column);
        }
        return accum;
    }, {
        sortRowColumn: [],
        selectRowColumn: [],
        groupedColumns: [],
        generalColumns: [],
        leftStickyColumns: [],
        rightStickyColumns: []
    });
}
function HeaderRow(_a) {
    var _b = _a.appearance, appearance = _b === void 0 ? "primary" : _b, _c = _a.uppercaseHeaderColumns, uppercaseHeaderColumns = _c === void 0 ? false : _c, _d = _a.disableColumnOrder, disableColumnOrder = _d === void 0 ? false : _d, headerGroup = _a.headerGroup, setColumnOrder = _a.setColumnOrder;
    var _e = groupColumns(headerGroup.headers), sortRowColumn = _e.sortRowColumn, selectRowColumn = _e.selectRowColumn, groupedColumns = _e.groupedColumns, leftStickyColumns = _e.leftStickyColumns, generalColumns = _e.generalColumns, rightStickyColumns = _e.rightStickyColumns;
    var tableLayoutEnabled = useTableLayoutEnabled();
    /* istanbul ignore next */
    function onSortEnd(_a) {
        var oldIndex = _a.oldIndex, newIndex = _a.newIndex;
        var next = groupedColumns
            .map(function (c) { return c.id; })
            .concat(leftStickyColumns.map(function (c) { return c.id; }))
            .concat(arrayMoveImmutable(generalColumns.map(function (c) { return c.id; }), oldIndex, newIndex))
            .concat(rightStickyColumns.map(function (c) { return c.id; }));
        setColumnOrder(next);
    }
    var width = tableLayoutEnabled ? { width: undefined } : {};
    var className = classNames("tw-group", "tw-box-content", appearance === "primary" &&
        !tableLayoutEnabled &&
        "tw-border-solid tw-border-gray-300 tw-border-b-0 tw-border-r tw-border-t tw-border-l dark:tw-border-blue-steel-800", appearance === "secondary" &&
        !tableLayoutEnabled &&
        "tw-border-solid tw-border-gray-300 tw-border-b-0 tw-border-r tw-border-t tw-border-l dark:tw-border-blue-steel-800");
    return (React.createElement("div", __assign({}, headerGroup.getHeaderGroupProps({
        style: __assign({ minHeight: appearance === "primary" ? "2rem" : "1rem", marginBottom: tableLayoutEnabled ? "-1px" : "" }, width)
    }), { className: className }),
        !!selectRowColumn.length && (React.createElement("div", { className: "tw-flex" }, selectRowColumn.map(function (column, index) { return (React.createElement(HeaderCell, { appearance: appearance, uppercaseHeaderColumns: uppercaseHeaderColumns, column: column, key: column.id, index: index })); }))),
        !!groupedColumns.length && (React.createElement("div", { className: "tw-flex" }, groupedColumns.map(function (column, index) { return (React.createElement(HeaderCell, { appearance: appearance, uppercaseHeaderColumns: uppercaseHeaderColumns, column: column, key: column.id, index: index })); }))),
        !!leftStickyColumns.length && (React.createElement("div", { className: "tw-flex tw-shadow-left dark:tw-shadow-dark-left", style: {
                background: "inherit",
                position: "sticky",
                left: 0,
                zIndex: 2
            } }, leftStickyColumns.map(function (column, index) { return (React.createElement(HeaderCell, { stickyLeft: true, appearance: appearance, uppercaseHeaderColumns: uppercaseHeaderColumns, column: column, key: column.id, index: index })); }))),
        React.createElement(OrderableColumnGroup, { axis: "x", className: "tw-flex tw-flex-grow", helperClass: classNames("tw-bg-gray-100 tw-z-10 tw-text-xs tw-text-default dark:tw-text-dark-bg", appearance === "primary" &&
                "tw-border-l dark:tw-border-blue-steel-800"), lockAxis: "x", lockToContainerEdges: true, useDragHandle: true, onSortEnd: onSortEnd }, generalColumns.map(function (column, index) { return (React.createElement(HeaderCell, { appearance: appearance, uppercaseHeaderColumns: uppercaseHeaderColumns, column: column, key: column.id, orderable: !disableColumnOrder, index: index, lastCell: generalColumns.length === index + 1 })); })),
        !!rightStickyColumns.length && (React.createElement("div", { className: "tw-flex tw-shadow-right dark:tw-shadow-dark-right", style: {
                background: "inherit",
                position: "sticky",
                right: 0
            } }, rightStickyColumns.map(function (column, index) { return (React.createElement(HeaderCell, { stickyRight: true, appearance: appearance, uppercaseHeaderColumns: uppercaseHeaderColumns, column: column, key: column.id, index: index, lastGroup: tableLayoutEnabled })); }))),
        !!sortRowColumn.length && (React.createElement("div", { className: "tw-flex" }, sortRowColumn.map(function (column, index) { return (React.createElement(HeaderCell, { appearance: appearance, uppercaseHeaderColumns: uppercaseHeaderColumns, column: column, key: column.id, index: index })); })))));
}

export { HeaderRow, groupColumns };
//# sourceMappingURL=HeaderRow.esm.js.map
